import React from 'react';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Courses } from './components/Courses';
import { Gallery } from './components/Gallery';
import { WhyUs } from './components/WhyUs';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { CrownDivider } from './components/CrownDivider';
export function App() {
  return <div className="min-h-screen bg-dark text-white selection:bg-gold selection:text-dark" data-id="element-0">
      {/* Fixed Navbar could go here, but a clean hero often works best without it until scroll.
              For simplicity and impact, we rely on the Hero CTAs and Footer navigation. */}

      <main data-id="element-1">
        <Hero data-id="element-2" />
        <CrownDivider data-id="element-3" />
        <Services data-id="element-4" />
        <CrownDivider data-id="element-5" />
        <Courses data-id="element-6" />
        <CrownDivider data-id="element-7" />
        <Gallery data-id="element-8" />
        <WhyUs data-id="element-9" />
        <Contact data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}